import { useEffect } from 'react'
import { useAppointmentCalendar } from '@context/AppointmentCalendarContext/AppointmentCalendarContext'

export const useScrollIntoView = (
  toggleMoreClinicsButtonRef: HTMLDivElement | null,
  selectedTimeslotRef: HTMLDivElement | null
) => {
  const { currentPeriod, shouldScrollToNearbyClinics, resetShouldScrollToNearbyClinics } = useAppointmentCalendar()
  const currentClinicsLength = Object.keys(currentPeriod).length

  useEffect(() => {
    if (shouldScrollToNearbyClinics && currentClinicsLength > 1 && toggleMoreClinicsButtonRef) {
      requestAnimationFrame(() => {
        toggleMoreClinicsButtonRef.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
      resetShouldScrollToNearbyClinics()
    }
  }, [currentClinicsLength, toggleMoreClinicsButtonRef, shouldScrollToNearbyClinics, resetShouldScrollToNearbyClinics])

  useEffect(() => {
    if (selectedTimeslotRef) {
      requestAnimationFrame(() => {
        selectedTimeslotRef.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    }
  }, [selectedTimeslotRef])
}
